export default {
  records(state) {
    return state.records;
  },
};
